import { useUpdateRoute } from "@features/mx/readCycleManagement/hooks";
import { Button } from "@shared/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@shared/ui/dialog";
import { useParams } from "react-router-dom";

interface RouteMoveMessageDialogProps {
  open: boolean;
  openMoveRouteDialog: (open: boolean) => void;
  onOpenChange: (open: boolean) => void;
  selectedRoutes: string[];
  selectedDestination: string | null;
  estimatedMeters: number;
}

const RouteMoveMessageDialog: React.FC<RouteMoveMessageDialogProps> = ({
  open,
  openMoveRouteDialog,
  onOpenChange,
  selectedRoutes,
  selectedDestination,
  estimatedMeters,
}) => {
  const { cycle_id } = useParams();
  const { mutateAsync: updateRoute } = useUpdateRoute(Number(selectedDestination), Number(cycle_id));
  const handleMoveRoutes = () => {
    if (selectedDestination) {
      const payload = {
        current_cycle_id: Number(cycle_id),
        new_cycle_id: Number(selectedDestination),
        routes: selectedRoutes,
      };
      updateRoute(payload);
      onOpenChange(false);
      openMoveRouteDialog(false);
    }
  };
  return (
    <div>
      {" "}
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
          <DialogHeader className="flex items-start justify-between">
            <div>
              <DialogTitle className="text-xl">Confirm route move</DialogTitle>
              <DialogDescription>
                You are about to move {selectedRoutes.length} routes to{" "}
                {selectedDestination}. This action cannot be undone.
              </DialogDescription>
            </div>
          </DialogHeader>

          <div className="space-y-4 py-4">
            <p className="page-subtitle">
              You are about to move {selectedRoutes.length} route(s) to the
              selected read cycle. As part of this move, the associated premises
              and {estimatedMeters} meter(s) will also be moved to the
              destination read cycle. Do you want to proceed?
            </p>
          </div>

          <DialogFooter className="flex justify-end gap-3">
            <Button variant="outline" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button
              onClick={handleMoveRoutes}
              disabled={!selectedDestination}
              className="bg-blue-600 hover:bg-blue-700"
            >
              Confirm Move
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default RouteMoveMessageDialog;
